import { GuardianExpoSection } from './GuardianExpoSubPageLayout'

/**
 * 活動照片區塊（正方形縮圖網格牆）
 * photos: [{ id, src, alt }]
 */
export default function PhotoGridSection({ titleBlack, titleRed, photos = [], onPhotoClick, last = false }) {
  return (
    <GuardianExpoSection titleBlack={titleBlack} titleRed={titleRed} last={last}>
      <div className="grid grid-cols-3 md:grid-cols-6" style={{ gap: 12 }}>
        {photos.map((photo, idx) => (
          <img
            key={photo.id}
            src={photo.src}
            alt={photo.alt}
            onClick={() => onPhotoClick?.(idx)}
            className="w-full aspect-square object-cover bg-white"
            style={{ borderRadius: 8, boxShadow: '2px 4px 8px rgba(110,98,91,0.08)', border: '1px solid rgba(110,98,91,0.08)', cursor: onPhotoClick ? 'zoom-in' : 'default' }}
          />
        ))}
      </div>
    </GuardianExpoSection>
  )
}
